import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { LMLoggerService } from './lm-logger.service';
import { DrillResource } from '@resources/drill.resource';
import { LMUrlUtilService } from './utils';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { LMFormRequest, LMModel } from '@form/index';
import { FormRequestType } from '@app/utils';
import * as urltemplate from 'url-template';

@Injectable()
export class LMDrillService {
  constructor(
    private http: HttpClient,
    private _logger: LMLoggerService,
    private urlUtilService: LMUrlUtilService,
    private lmLoggerService: LMLoggerService) {
  }

  public getDrillPoints(drillPointsParams: DrillPointsParams): Observable<LMDrillAction[]> {
    if (drillPointsParams.dataView === undefined) {
      return;
    }

    const drillResource = new DrillResource({ resourceId: drillPointsParams.dataView.resourceId, drillName: '_drillpoints_' });
    const url = this.urlUtilService.buildUrl({ resource: drillResource });

    const headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json;charset=utf-8');

    return <Observable<LMDrillAction[]>> this.http.get(url, {headers}).pipe(
      catchError(error => this._handleError(error)));
  }

  public getFieldDrillPoints(drillPointsParams: DrillPointsParams): Observable<LMDrillResponse> {
    if (drillPointsParams.model === undefined) {
      return;
    }

    const compiledFormRequestUrl = urltemplate.parse(drillPointsParams.model.formUrlInfo.formRequestUrl);
    const url = compiledFormRequestUrl.expand({ resourceId: drillPointsParams.model.formResourceId });

    const formRequest: LMFormRequest = {
      requestType: FormRequestType.DrillPoints,
      dataView:    drillPointsParams.model.getData(),
      drillName:   '_drillPoints_',
      fieldId:     drillPointsParams.fieldId
    };

    const headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json;charset=utf-8');

    return <Observable<LMDrillResponse>> this.http.post(url, JSON.stringify(formRequest), {headers}).pipe(
      catchError(error => this._handleError(error)));
  }

  private _handleError(error: Response) {
    // in a real world app, we may send the error to some remote logging infrastructure
    // instead of just logging it to the console
    this.lmLoggerService.log(error);
    return throwError(error || 'Server error');
  }
}

export interface DrillPointsParams {
  dataView?: LMDataView;
  model?:    LMModel;
  fieldId?:  string;
}
